import React from "react";
import {
  List,
  Datagrid,
  EmailField,
  TextField,
  TextInput,
  EditButton,
  BooleanField,
  FunctionField,
  SelectInput,
  Filter,
} from "react-admin";
import Chip from "@material-ui/core/Chip";
import { colors, styles } from "../styles";
import CountriesFlags from "../images/countriesFlags";
import RangeDatePicker from "../components/inputs/RangeDatePicker/RangeDatePicker";
import TernaryField from "../components/fields/TernaryField";
import RenderDate from "../components/fields/RideDateField";
import { countries } from "../utils/countries";
import ShowComponent from "./ShowComponent";
import ApproveComponent from "./ApproveComponent";

const CompanyFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Email" source="email" alwaysOn style={styles.input} />
    <TextInput label="Name" source="name" alwaysOn style={styles.input} />
    <SelectInput
      label="Company role"
      source="companyRole"
      style={styles.input}
      addLabel
      alwaysOn
      choices={[
        { id: "CARRIER", name: "Carrier" },
        { id: "SUPPLIER", name: "Supplier" },
      ]}
    />
    <SelectInput
      label="Country"
      source="country"
      style={styles.input}
      addLabel
      alwaysOn
      choices={countries}
    />
    <RangeDatePicker
      source="createdAt"
      alwaysOn
      filterValues={props.filterValues}
      style={styles.input}
    />
  </Filter>
);

const renderRide = (ride) => <RenderDate ride={ride} type="createdAt" />;

const CompanyRoleField = (props) => {
  return <Chip label={props.record.companyRole} style={styles.chip} />;
};

const CountryField = (props) => {
  return (
    <Chip
      label={
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={CountriesFlags[props.record.country]}
            alt="flag"
            style={{ width: 24, height: 24, marginRight: "8px" }}
          />
          {props.record.country}
        </div>
      }
      style={styles.chip}
    />
  );
};

export default (props) => (
  <List
    {...props}
    title="All companies"
    perPage={25}
    bulkActionButtons={false}
    filters={<CompanyFilter />}>
    <Datagrid>
      <TextField source="name" sortable style={styles.title} />
      <EmailField source="email" sortable style={styles.title} />
      <BooleanField
        source="active"
        sortable={false}
        style={{ color: colors.main }}
      />
      <ApproveComponent label="Approved company" />
      <BooleanField
        source="excelImportErrors"
        sortable={false}
        style={{ color: colors.main }}
      />
      <ShowComponent label="Show excel errors" />
      <FunctionField
        label="Country"
        sortBy="country"
        render={(record) => <CountryField record={record} />}
      />
      <FunctionField
        label="Company role"
        sortBy="companyRole"
        render={(record) => <CompanyRoleField record={record} />}
      />
      <FunctionField
        label="Registration Date"
        sortBy="createdAt"
        render={renderRide}
      />
      <TextField source="registrationOrigin" sortable style={styles.title} />
      <TernaryField label="Beneficiary" source="isBeneficiaryOk" sortable />
      <TernaryField label="Consumer" source="isConsumerOk" sortable />
      <EditButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/companies/List.js